export * from './MotivoDaMovimentacaoServiceAdapter'